import { render, staticRenderFns } from "./PartsRequestForFault.vue?vue&type=template&id=185c4570&scoped=true&"
import script from "./PartsRequestForFault.vue?vue&type=script&lang=js&"
export * from "./PartsRequestForFault.vue?vue&type=script&lang=js&"
import style0 from "./PartsRequestForFault.vue?vue&type=style&index=0&id=185c4570&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "185c4570",
  null
  
)

export default component.exports